// ISO 3166-1 alpha-2 codes are what the database stores; people read country names.
const display = typeof Intl !== 'undefined' && Intl.DisplayNames
  ? new Intl.DisplayNames(['en'], { type: 'region' })
  : null;

export const countryName = (value) => {
  if (!value) return null;
  const code = String(value).trim();
  if (code.length !== 2) return code;
  try {
    return display?.of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
};

export default countryName;
